module.exports = __webpack_public_path__ + "img/debtPayingAbility9.8aad9b61.png";